import React from 'react';

import Diversion from '../components/Diversion';

class DiversionLandingPage extends React.Component {
  render() {
    return (
      <div>
        <h2>
          Diversion
        </h2>

        <Diversion />
      </div>
    );
  }
}

export default DiversionLandingPage;



// WEBPACK FOOTER //
// ./src/pages/Diversion.js